// extracted by mini-css-extract-plugin
module.exports = {"TagSpacer":"TagList_TagSpacer_34Zqq"};